import Vue from 'vue'
import FeatherIcon from '@core/components/feather-icon/FeatherIcon.vue'
import DataTable from '@core/components/data-table/View.vue'
import OptionTag from '@core/components/option-tag/View.vue'
import DataTableSsr from '@core/components/data-table-ssr/View.vue'
import DataCreatePopup from '@core/components/data-create-popup/View.vue'
import DataUpdatePopup from '@core/components/data-update-popup/View.vue'
import DyanamicZone from '@core/components/dynamic-zone/View.vue'
import ConfigRateList from '@core/components/config-rate-list/View.vue'
import MultiSelect from '@core/components/multi-select/View.vue'
import DatetimePicker from '@core/components/datetime-picker/View.vue'
import FormGenerator from '@core/components/form-generator/View.vue'
import UiComponent from '@core/layouts/components/input-fields/UiComponent.vue'
import UiComponentList from '@core/layouts/components/input-fields/UiComponentList.vue'
import ActionButtons from '@core/layouts/components/action-buttons/ActionButtons.vue'
import DeleteButton from '@core/layouts/components/action-buttons/DeleteButton.vue'
import UpdateButton from '@core/layouts/components/action-buttons/UpdateButton.vue'
import LoadingButton from '@core/layouts/components/action-buttons/LoadingButton.vue'
import PageBreadcrumb from '@core/layouts/components/PageBreadcrumb.vue'
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'
import TooltipButton from '@/modules/post/views/_components/TooltipButton.vue'
import BootstrapVue from 'bootstrap-vue'
import LanguageSelect from '@/modules/language/views/_components/LanguageSelect.vue'
import RenderTranslatableText from '@core/layouts/components/input-fields/translatable-text-field/RenderTranslatableText.vue'
import { heightFade } from '@core/directives/animations'
import BreakingComponent from '@core/layouts/components/breaking-components/Breaking-component.vue'
import '@core/components/more-actions/index';
Vue.component(FeatherIcon.name, FeatherIcon)
Vue.component(DataTable.name, DataTable)
Vue.component(OptionTag.name, OptionTag)
Vue.component(DataTableSsr.name, DataTableSsr)
Vue.component(DataCreatePopup.name, DataCreatePopup)
Vue.component(DataUpdatePopup.name, DataUpdatePopup)
Vue.component(DyanamicZone.name, DyanamicZone)
Vue.component(ConfigRateList.name, ConfigRateList)
Vue.component(MultiSelect.name, MultiSelect)
Vue.component(DatetimePicker.name, DatetimePicker)
Vue.component(FormGenerator.name, FormGenerator)
Vue.component(UiComponent.name, UiComponent)
Vue.component(UiComponentList.name, UiComponentList)
Vue.component(ActionButtons.name, ActionButtons)
Vue.component(DeleteButton.name, DeleteButton)
Vue.component(UpdateButton.name, UpdateButton)
Vue.component(LoadingButton.name, LoadingButton)
Vue.component(PageBreadcrumb.name, PageBreadcrumb)
Vue.component('AppCollapse', AppCollapse)
Vue.component('AppCollapseItem', AppCollapseItem)
Vue.component(TooltipButton.name, TooltipButton)
Vue.component(LanguageSelect.name, LanguageSelect)
Vue.component(RenderTranslatableText.name, RenderTranslatableText)
Vue.use(BootstrapVue)
Vue.directive('height-fade', heightFade)
Vue.component(BreakingComponent.name, BreakingComponent)
